import { type FC } from 'react'

import { EMPTY_LABEL } from '@/constants'

type Props = {
  value: number | null | undefined
  emptyLabel?: string | null
  /** 小数点の最小・最大桁数を指定 */
  option?: Pick<
    Intl.NumberFormatOptions,
    'minimumFractionDigits' | 'maximumFractionDigits'
  >
  /** マイナス値を▲記号+赤字で表示する（日本の会計表記） */
  showTriangleForNegative?: boolean
}

/**
 * 数値をカンマ区切りにフォーマットする
 */
export const NumberFormatter: FC<Props> = ({
  value,
  emptyLabel = EMPTY_LABEL,
  option,
  showTriangleForNegative = false
}) => {
  if (value == null) return <>{emptyLabel}</>

  if (showTriangleForNegative && value < 0) {
    return (
      <span className="text-red-600">
        ▲{Math.abs(value).toLocaleString(undefined, option)}
      </span>
    )
  }

  return <>{value.toLocaleString(undefined, option)}</>
}
